export const footerTabletTemplate = '1fr 1fr';
export const template = 'repeat(6, 1fr) 64px';
export const titles = [
  'Date',
  'Amount',
  'Type',
  'Employee',
  'Notes',
  'Category',
  '',
];
export const paths = [
  'date',
  'type',
  'notes',
  'amount',
  'event.name',
  'category.name',
  'employee.user.name',
];
